import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 32px;
  gap: 32px;
  min-height: 100vh;
  background: ${({ theme }) => theme.color.background};
  overflow-y: auto;
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  background: ${({ theme }) => theme.color.white};
  border-radius: 8px;
  border-right: 1px solid ${({ theme }) => theme.color.grey200};
  border-bottom: 1px solid ${({ theme }) => theme.color.grey200};
  border-left: 1px solid ${({ theme }) => theme.color.grey200};
  box-shadow: 1px 1px 0 0 rgba(11, 37, 80, 0.17);
`;

export const ContentDivider = styled.div`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.color.grey200};
`;

export const EditContent = styled.div`
  flex-grow: 1;
`;

export const EditWrapper = styled.div`
  display: flex;
  width: 100%;

  // > div:first-child {
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: space-between;
  //   margin-bottom: 80px;
  //   border-bottom: 1px solid ${({ theme }) => theme.color.grey200};
  //   padding: 0 64px 32px 0;
  // }
`;
